import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const reviews = [
  {
    name: "Marisol G.",
    area: "Coral Gables — Pre-Purchase",
    text: "Safe Point found a hidden roof-deck issue the seller's disclosure missed. The same-day report saved us $14k in negotiations.",
  },
  {
    name: "Daniel & Priya R.",
    area: "Miami — Wind Mitigation",
    text: "Our insurance premium dropped 31% after the wind mitigation report. The inspection paid for itself in the first month.",
  },
  {
    name: "Coach T. Williams",
    area: "Fort Lauderdale — 4-Point",
    text: "Citizens needed a 4-point on our 1988 home fast. Booked online at 9am, report in my inbox by dinner. Zero friction.",
  },
];

export const Reviews = () => (
  <section id="reviews" className="bg-sand py-28 sm:py-36 blueprint-grid-light">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="mb-16 flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <div>
          <div className="font-mono text-xs tracking-[0.25em] text-terra uppercase font-semibold mb-4">/ Field Reports</div>
          <h2 className="font-display font-bold tracking-tight text-obsidian text-2xl sm:text-3xl lg:text-4xl leading-tight">
            Homeowners who bought with certainty.
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={16} className="fill-terra text-terra" />
            ))}
          </div>
          <span className="font-mono text-xs tracking-widest text-slate-500">5.0 · 380+ REVIEWS</span>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {reviews.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.12, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`review-card-${i + 1}`}
            className={`bg-paper border border-sandline rounded-2xl p-8 flex flex-col transition-shadow duration-500 hover:shadow-xl hover:shadow-obsidian/5 ${
              i === 1 ? "md:-translate-y-6" : ""
            }`}
          >
            <Quote size={26} className="text-terra mb-5" />
            <blockquote className="text-slate-700 text-sm sm:text-base leading-relaxed flex-1">"{r.text}"</blockquote>
            <figcaption className="mt-7 pt-5 border-t border-sandline">
              <div className="font-display font-bold text-obsidian">{r.name}</div>
              <div className="font-mono text-[10px] tracking-[0.2em] text-slate-400 uppercase mt-1">{r.area}</div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
